import * as tool from './tool';
import * as dom from './dom';
import * as map from './map';

const utils = {
  ...tool,
  ...dom,
  ...map,
};

export default utils;
